import React, { useState } from 'react';
import {
  RadioGroup,
  Radio,
  FormControlLabel,
  FormControl,
  FormLabel,
  withStyles,
  FormGroupProps,
} from '@material-ui/core';

const ColorRadio = withStyles({
  root: {
    padding: 1,
    '& svg': {
      width: '1.2em',
      height: '1.2em',
      color: '#636363',
    },
  },
  checked: {
    '&$checked svg': {
      color: 'black',
    },
  },
})((props) => <Radio color="default" className={`yoga-ui-radio-button`} style={{ marginRight: '10px' }} {...props} />);

const RadioButtons = ({
  options,
  setRadioValue,
}: {
  options: RadioButtonsOptions;
  setRadioValue: (value: string) => void;
}) => {
  const {
    labelValuePairs,
    defaultSelected = false,
    formLabel = '',
    wrapperClasses = '',
    radioGroupClasses = '',
    radioRowClasses = '',
    defaultValue = '',
  } = options;

  const initialSelectedValue = defaultValue || (defaultSelected && labelValuePairs[0] ? labelValuePairs[0][1] : '');
  const [selected, selectOption] = useState(initialSelectedValue);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    selectOption(event.target.value);
    setRadioValue(event.target.value);
  };

  return (
    <FormControl
      style={{ width: '100%', color: 'var(--chicago)' }}
      className={`yoga-ui-radio-buttons ${wrapperClasses}`}
    >
      {formLabel !== '' && <FormLabel>{formLabel}</FormLabel>}
      <RadioGroup
        aria-labelledby="radio-buttons-group"
        defaultValue={defaultValue}
        value={selected || defaultValue}
        name=""
        onChange={handleChange}
        className={`yoga-ui-radio-group ${radioGroupClasses}`}
      >
        {labelValuePairs.map(([label, value]) => (
          <FormControlLabel
            value={value}
            control={<ColorRadio />}
            label={label}
            className={`yoga-ui-radio-row ${radioRowClasses} ${value === selected ? `active` : ``}`}
            style={value === selected ? highlightSelectedStyles : {}}
          />
        ))}
      </RadioGroup>
    </FormControl>
  );
};

const highlightSelectedStyles = {
  color: 'black',
  backgroundColor: 'transparent',
};

export default RadioButtons;

interface RadioButtonsOptions {
  labelValuePairs: string[][];
  defaultSelected?: boolean;
  formLabel?: string;
  wrapperClasses?: string;
  radioGroupClasses?: string;
  radioRowClasses?: string;
  defaultValue?: FormGroupProps['defaultValue'];
}
